export const ListQueryKey = 'inboxList';
export const DetailQueryKey = 'inbox';

export const Urls = {
  selectUrl: '/inbox/list',
  updateUrl: '/inbox/update',
  deleteUrl: '/inbox/delete',
  createUrl: '/inbox/create',
  detailUrl: '/inbox/detail',
};
